import { makeStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

interface MenuItemProps {
  selected: boolean;
  label: string;
  callback: (_: React.MouseEvent<HTMLButtonElement>) => void;
}

const useStyles = makeStyles((theme) => ({
  menuButton: {
    textTransform: "none",
    paddingLeft: 30,
  },
  menuButtonSelected: {
    textTransform: "none",
    paddingLeft: 30,
    borderLeftWidth: 7,
    borderLeftColor: theme.palette.primary.dark,
    borderLeftStyle: "solid",
    borderRadius: 0,
  },
  menuItemLabel: {
    fontWeight: 400,
    fontSize: 16,
    color: theme.palette.primary.dark,
  },
  menuItemLabelSelected: {
    fontWeight: 700,
    fontSize: 16,
    color: theme.palette.primary.dark,
  },
}));

export const MenuItem = (props: MenuItemProps) => {
  const classes = useStyles();
  const { selected, label, callback } = props;

  return (
    <Button
      onClick={callback}
      className={selected ? classes.menuButtonSelected : classes.menuButton}
    >
      <Typography
        className={
          selected ? classes.menuItemLabelSelected : classes.menuItemLabel
        }
        variant="h4"
        component="h4"
      >
        {label}
      </Typography>
    </Button>
  );
};
